import useWindowPositionTop from 'hooks/useWindowPositionTop';
export default function CourseForAdults() {
    useWindowPositionTop();
  return (
    <>
      <style>{`
        .basic-course {
          white-space: pre-line;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.6;
          margin: 0 auto;
          padding: 8rem 2rem;
          box-sizing: border-box;
          background: #fff;
          color: #222;
          border-radius: 8px;
          transition: padding 0.3s ease;
          max-width: 720px;
        }

        .basic-course h2 {
          font-size: 2.25rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #003366;
          line-height: 1.1;
        }

        .basic-course p {
          margin-bottom: 1.25rem;
          font-size: 1.125rem;
          font-weight: 400;
          color: #333;
        }

        .basic-course ul {
          margin-bottom: 1.75rem;
          padding-left: 1.5rem;
          list-style-type: disc;
          color: #444;
        }

        .basic-course ul li {
          margin-bottom: 0.6rem;
          font-size: 1.05rem;
          line-height: 1.4;
        }

        .basic-course strong {
          font-weight: 700;
          color: #002244;
        }

        .basic-course .highlight {
          font-weight: 700;
          font-size: 1.2rem;
          color: #b22222;
          margin-top: 2rem;
        }

        /* Responsive typography and spacing */
        @media (max-width: 1024px) {
          .basic-course h2 {
            font-size: 1.9rem;
          }
          .basic-course p,
          .basic-course ul li {
            font-size: 1rem;
          }
        }

        @media (max-width: 600px) {
          .basic-course h2 {
            font-size: 1.6rem;
          }
          .basic-course p,
          .basic-course ul li {
            font-size: 0.95rem;
          }
          .basic-course ul {
            padding-left: 1.2rem;
          }
        }

        @media (max-width: 360px) {
          .basic-course h2 {
            font-size: 1.4rem;
          }
          .basic-course p,
          .basic-course ul li {
            font-size: 0.9rem;
          }
        }
      `}</style>

      <div className="basic-course">
        <h2>Базовый курс английского языка для взрослых</h2>
        <p>
          Учил английский в школе, колледже или институте, но так и не заговорил на нём? Вы сами удивитесь, как Вы начнёте говорить простыми предложениями уже после первых занятий.
        </p>
        <p><strong>🔑 ОСВОЙ АНГЛИЙСКИЙ С НУЛЯ БЕЗ МУЧИТЕЛЬНОЙ ЗАУЧИВАНИЯ!</strong></p>
        <p>
          Базовый курс английского языка — ваш надёжный старт в мир свободного общения!
        </p>

        <p><strong>✨ Преимущества курса:</strong></p>
        <ul>
          <li>Структурированная программа для начинающих</li>
          <li>Практический подход к обучению</li>
          <li>Комфортная атмосфера занятий</li>
          <li>Индивидуальный темп обучения</li>
        </ul>

        <p><strong>🎯 Что вы получите:</strong></p>
        <ul>
          <li>Уверенное владение базовой грамматикой</li>
          <li>Активный словарный запас 1500+ слов</li>
          <li>Навыки разговорной речи уже с первых занятий</li>
          <li>Понимание английской речи на слух по фильмам, мультфильмам и песням</li>
          <li>Умение читать простые тексты</li>
        </ul>

        <p><strong>🏆 Особенности обучения:</strong></p>
        <ul>
          <li>Современные методики — учим так, как работает мозг</li>
          <li>Практические занятия — говорим с первого дня</li>
          <li>Интерактивные материалы — обучение в формате диалога</li>
          <li>Моя ежедневная поддержка — ответы на все вопросы</li>
        </ul>

        <p><strong>🎪 Программа курса включает:</strong></p>
        <ul>
          <li>Фонетика — правильное произношение с нуля</li>
          <li>Грамматика — базовые конструкции и правила</li>
          <li>Лексика — актуальная повседневная лексика</li>
          <li>Практика общения — живые диалоги и ролевые игры</li>
        </ul>

        <p><strong>🎁 Дополнительные бонусы:</strong></p>
        <ul>
          <li>Доступ к онлайн-платформе</li>
          <li>Все занятия в записи</li>
          <li>Домашние задания с проверкой</li>
          <li>Индивидуальные консультации</li>
          <li>Методические материалы</li>
          <li>Сертификат об окончании</li>
        </ul>

        <p><strong>⏰ Формат обучения:</strong></p>
        <ul>
          <li>Групповые занятия</li>
          <li>Индивидуальные консультации</li>
          <li>Онлайн-формат</li>
          <li>Удобное расписание</li>
        </ul>

        <p><strong>💰 Специальное предложение:</strong></p>
        <ul>
          <li>Скидка 20% на полный курс</li>
          <li>Бесплатное пробное занятие</li>
          <li>Персональная программа обучения</li>
          <li>Бонус — набор учебных материалов</li>
        </ul>

        <p>
          Не откладывай свою мечту о владении английским на потом!
        </p>

        <p className="highlight">
          📞 ЗАПИШИСЬ НА ПРОБНОЕ ЗАНЯТИЕ ПРЯМО СЕЙЧАС!<br />
          Количество мест в группах ограничено!<br />
          Начни свой путь к свободному английскому уже сегодня!
        </p>

        <p>#английскийязык #базовыйанглийский #обучениеанглийскому #курсыанглийского #английскийдлявзрослых</p>
      </div>
    </>
  );
}

